import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["dismissable", "hasDownArrow", "onDismiss", "width", "onClick", "dismissProps", "disabled", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled from 'styled-components';
import { useThemeDefaults } from '../utils';
import { buttonBase, InteractiveText } from '../Button/base';
import Box from '../Box';
import CloseIcon from '../Icons/CloseIcon';
import DownIcon from '../Icons/DownIcon';

var centerLine = function centerLine(props) {
  return {
    '&::after': {
      content: '""',
      position: 'absolute',
      backgroundColor: props.theme.colors.keyline,
      width: '1px',
      left: '0px',
      top: '3px',
      bottom: '3px'
    }
  };
};

var filterButtonStyles = function filterButtonStyles(props) {
  return {
    as: 'button',
    type: 'button',
    cursor: props.disabled ? 'default' : 'pointer',
    color: props.disabled ? 'ctrlDisabled' : 'label',
    bg: 'ctrlBg',
    borderColor: 'ctrlBg',
    hoverBg: 'ctrlBg',
    hoverColor: props.disabled ? 'ctrlDisabled' : 'ctrl'
  };
};

var BaseFilterButton = useThemeDefaults(function (props) {
  return _objectSpread(_objectSpread(_objectSpread({}, buttonBase(props)), filterButtonStyles(props)), {}, {
    borderRadius: props.dismissable ? "".concat(props.theme.radius, " 0 0 ").concat(props.theme.radius) : "regular"
  });
}, InteractiveText);
var FilterDismiss = useThemeDefaults(function (props) {
  return _objectSpread(_objectSpread(_objectSpread({}, buttonBase(props)), filterButtonStyles(props)), {}, {
    position: 'relative',
    borderRadius: "0 ".concat(props.theme.radius, " ").concat(props.theme.radius, " 0")
  });
}, styled(InteractiveText).withConfig({
  displayName: "FilterButton__FilterDismiss",
  componentId: "sc-1kon51q-0"
})(centerLine));

var _ref2 = /*#__PURE__*/React.createElement(DownIcon, {
  width: "0.65em",
  height: "0.65em",
  ml: "5px"
});

var _ref3 = /*#__PURE__*/React.createElement(CloseIcon, {
  width: "0.65em",
  height: "0.65em"
});

var FilterButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var dismissable = _ref.dismissable,
      hasDownArrow = _ref.hasDownArrow,
      _ref$onDismiss = _ref.onDismiss,
      onDismiss = _ref$onDismiss === void 0 ? function () {} : _ref$onDismiss,
      width = _ref.width,
      onClick = _ref.onClick,
      dismissProps = _ref.dismissProps,
      disabled = _ref.disabled,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "inline-block",
    ref: ref
  }, props), /*#__PURE__*/React.createElement(BaseFilterButton, {
    disabled: disabled,
    dismissable: dismissable,
    width: width,
    onClick: onClick
  }, children, hasDownArrow && _ref2), dismissable && /*#__PURE__*/React.createElement(FilterDismiss, _extends({
    disabled: disabled,
    onClick: onDismiss
  }, dismissProps), _ref3));
});
export default FilterButton;